var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#FEE5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5963 14.82C24.9127 14.0396 24.536 13.0374 24.5363 12H21.4462V24.4C21.4224 25.071 21.1391 25.7066 20.656 26.1729C20.1729 26.6393 19.5277 26.8999 18.8562 26.9C17.4362 26.9 16.2563 25.74 16.2563 24.3C16.2563 22.58 17.9163 21.29 19.6263 21.82V18.66C16.1763 18.2 13.1562 20.88 13.1562 24.3C13.1562 27.63 15.9163 30 18.8463 30C21.9863 30 24.5363 27.45 24.5363 24.3V18.01C25.7892 18.9099 27.2936 19.3926 28.8363 19.39V16.3C28.8363 16.3 26.9563 16.39 25.5963 14.82Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.1f8d7578c4ee917a35f81134250b0cb1.svg";
export { ForwardRef as ReactComponent };